import { LoginContext, User } from '../types';
import { omit } from 'lodash';

export const saveUserData = (userData: User) => {
  const userDataNoBrands: User = {
    ...userData,
    loginContexts: userData.loginContexts.map((loginContext: LoginContext) =>
      omit(loginContext, 'brands')
    ),
  };
  localStorage.setItem('auth_userdata', JSON.stringify(userDataNoBrands));
};

export const saveToken = (loginContext: LoginContext) => {
  localStorage.setItem('auth_login_context', JSON.stringify(omit(loginContext, 'brands')));
};

// Re-export from lib/react-query-auth to maintain backward compatibility
export { deleteUserData, deleteToken } from 'lib/react-query-auth/utils';

export const getUserData = () => {
  const userDataJson = localStorage.getItem('auth_userdata');
  const userData: User | null = userDataJson ? JSON.parse(userDataJson) : null;
  const loginContextJson = localStorage.getItem('auth_login_context');
  const loginContext: LoginContext = loginContextJson ? JSON.parse(loginContextJson) : null;
  return { userData, loginContext };
};
